var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "local_activity_black_24dp 1",
    clipPath: "url(#clip0_4091_11867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6665 10.0002C16.6665 9.0835 17.4165 8.3335 18.3332 8.3335V5.00016C18.3332 4.0835 17.5832 3.3335 16.6665 3.3335H3.33317C2.4165 3.3335 1.67484 4.0835 1.67484 5.00016V8.3335C2.5915 8.3335 3.33317 9.0835 3.33317 10.0002C3.33317 10.9168 2.5915 11.6668 1.6665 11.6668V15.0002C1.6665 15.9168 2.4165 16.6668 3.33317 16.6668H16.6665C17.5832 16.6668 18.3332 15.9168 18.3332 15.0002V11.6668C17.4165 11.6668 16.6665 10.9168 16.6665 10.0002ZM12.9832 14.0002L9.99984 12.0835L7.0165 14.0002L7.9165 10.5668L5.17484 8.32516L8.70817 8.11683L9.99984 4.8335L11.2832 8.12516L14.8165 8.3335L12.0748 10.5752L12.9832 14.0002Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_11867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.896c1d7e5c876b641472f52e7d917bca.svg";
export { ForwardRef as ReactComponent };